// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"cooperate"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M1.5 10.5L12 21L19.5 13.5L15 9L12 12L9 9L12 6L9 3L1.5 10.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M15 3L12 6L9 9L12 12L15 9L19.5 13.5L22.5 10.5L15 3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 6L9 3L1.5 10.5L12 21L19.5 13.5M12 6L9 9L12 12L15 9L19.5 13.5M12 6L15 3L22.5 10.5L19.5 13.5M14.3684 18.632L12 16.2637M16.7365 16.2629L14.3682 13.8945","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-cooperate')
export default class CooperateIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'cooperate',
    }
  }
}
